export default function createItemsMarkup(array) {
    const item = array.map(({src,name,category,price})=> {
        return `
        <li class="store__product">
            <img class="store__img" src="${src}" alt="image">
            <div class="store__box">
            <div class="store__text">
            <h2 class="store__name">${name}</h2>
            <p class="store__category">${category}</p>
            <p class="store__price">${price}₴</p>
            </div>
            <button type="button" class="store__btn-plus">+</button></div>
          </li>`
          
          
    }).join("");
    return item;
}